module.exports = __webpack_public_path__ + "img/novaholding.247828af.jpg";